import React from 'react';
import { Divider, Paper, Typography } from '@mui/material';
import { currencyFormat, ROADSIDE_ASSISTANCE_PRICING_TYPE } from '../../constants';
import useRepair from '../../resources/repairs/read';
import Detail from './Detail';

const LoanDetails = ({ loanPackage }) => {
  const { data: repair } = useRepair();

  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: '#F5F5F5',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
        pt: 1,
        pr: 2,
        pb: 2,
        pl: 2,
      }}
    >
      <Typography variant="caption" sx={{ lineHeight: '32px', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Loan Details
      </Typography>
      <Detail label="Financing Amount" value={currencyFormat.format(repair.attributes.actual_amount)} />
      {loanPackage.pricing_type === ROADSIDE_ASSISTANCE_PRICING_TYPE
        && loanPackage.ancillary_charge && (
        <Detail label="Roadside Assistance" value={currencyFormat.format(loanPackage.ancillary_charge)} />
      )}
      <Detail label="Loan Origination Fee" value={currencyFormat.format(loanPackage.origination_charge)} />
      <Divider />
      <Detail label="Total Amount" value={currencyFormat.format(loanPackage.amount)} />
      <Detail label="Monthly Payment" value={currencyFormat.format(loanPackage.payment)} />
      <Detail label="Loan Term" value={`${loanPackage.term} Months`} />
      <Detail label="Interest Rate" value={`${(parseFloat(loanPackage.rate)).toFixed(2)}%`} />
      <Detail label="APR" value={`${(parseFloat(loanPackage.apr)).toFixed(2)}%`} />
    </Paper>
  );
};

export default LoanDetails;
